"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBSearchIndividualLineComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../../shared/services/account.service");
const index_1 = require("../../shared/index");
const _ = require("underscore");
const router_1 = require("@angular/router");
class CSBBSearchIndividualLineComponent {
    constructor(router, helperService, accountService) {
        this.router = router;
        this.helperService = helperService;
        this.accountService = accountService;
    }
    ngOnInit() {
        this.subscriptions = [];
        this.accountService.emitWSDLLoadStatus$.subscribe((accountInfoStatus) => {
            if (accountInfoStatus === 'true') {
                this.getLiteAccountInfo(false);
            }
        });
    }
    ngOnChanges(changes) {
        if (changes['subId']) {
            if (!_.isEmpty(this.subId)) {
                this.router.navigate(['/business/singleline']);
            }
        }
        // if (changes['subscriptionDetails']) {
        //    this.setSubscriptions();
        // }
    }
    setSubId(subId) {
        if (!_.isEmpty(subId.subscriptionId)) {
            this.router.navigate(['/business/singleline'], { queryParams: { subId: subId.subscriptionId } });
        }
    }
    getLiteAccountInfo(cacheResponse) {
        this.loader = true;
        this.accountService.getAccountDetailsLite(cacheResponse).subscribe((res) => {
            this.loader = false;
            this.subscriptions = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSBBSearchIndividualLineComponent = CSBBSearchIndividualLineComponent;
//# sourceMappingURL=search-individual-line.component.js.map